module.exports = __webpack_public_path__ + "img/portfolio-06.0302d0fe.jpg";